<template>
  <div class="cursor-pointer test-sheet mb-5 translate-as-whole-pointer" @click="download">
    <img src="@/assets/orderTest/order-page/pdf_logo_21px.svg" alt="" /> 
    View Test Price Sheet
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
      fileName: '2024 Vibrant Test Pricing & TAT Sheet.pdf',
      fileLinkMap: {
        USD: "https://hello.vibrant-wellness.com/hubfs/Resources/Price-Sheet.pdf",
        GBP: "https://hello.vibrant-wellness.com/hubfs/Resources/Price-Sheets/Pound-Sterling-Price-Sheet.pdf",
        EUR: "https://hello.vibrant-wellness.com/hubfs/Resources/Price-Sheets/Euro-Price-Sheet.pdf",
        CHF: "https://hello.vibrant-wellness.com/hubfs/Resources/Price-Sheets/Swiss-Franc-Price-Sheet.pdf"
      }
    };
  },
  computed: {
    ...mapState(["currency"]),
  },
  methods: {
    download() {
      let url = this.fileLinkMap.USD;
      if (this.currency && this.currency.name) {
        url = this.fileLinkMap[this.currency.name.toUpperCase()] ? this.fileLinkMap[this.currency.name.toUpperCase()] : url;
      }

      window.open(url,"_blank")
    }
  }
}
</script>

<style scoped>
.test-sheet {
  border-radius: var(--radius, 4px);
  border: 1px solid var(--color-Cyan-000, #20A7C1);

  display: flex;
  width: 373px;
  height: 36px;
  padding: var(--V-padding, 12px) var(--H-padding, 20px);
  justify-content: center;
  align-items: center;
  gap: var(--Spacing, 8px);


  color: var(--color-Cyan-000, #20A7C1);
  text-align: center;

  /* Body Medium 16 */
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
</style>